export type VideoCategory = "movie" | "tv" | "variety";

export interface VideoItem {
  id: string;
  title: string;
  category: VideoCategory;
  categoryLabel: string;
  year: number;
  region: string;
  duration: string;
  rating: number;
  cover: string;
  backdrop: string;
  description: string;
  director: string;
  cast: string[];
  tags: string[];
  publishDate: string;
}

export const categoryMeta: Record<VideoCategory, { label: string; slug: string; intro: string }> = {
  movie: {
    label: "电影",
    slug: "movie",
    intro: "汇聚院线大片与经典佳作，动作、科幻、悬疑、爱情一网打尽，高清画质在线畅看。",
  },
  tv: {
    label: "电视剧",
    slug: "tv",
    intro: "热播剧集持续更新，都市、古装、悬疑、家庭多题材全覆盖，追剧不迷路。",
  },
  variety: {
    label: "综艺",
    slug: "variety",
    intro: "音乐、美食、真人秀、脱口秀轮番上演，轻松欢乐随时点开就能看。",
  },
};

export const regionOptions = ["全部", "中国大陆", "美国", "英国", "韩国", "日本", "中国香港"];
export const yearOptions = ["全部", "2026", "2025", "2024", "2023", "2022", "2021"];

export const videos: VideoItem[] = [
  {
    id: "m01",
    title: "星际远征",
    category: "movie",
    categoryLabel: "电影",
    year: 2026,
    region: "美国",
    duration: "2小时18分",
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20ringed%20planet%2C%20deep%20space%20nebula%20background%2C%20dramatic%20blue%20and%20orange%20rim%20lighting%2C%20floating%20cosmic%20dust%20and%20stars%2C%20highly%20detailed%20digital%20painting%2C%20epic%20science%20fiction%20atmosphere&width=480&height=720&seq=vid-m01-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20science%20fiction%20film%20still%20of%20an%20alien%20planet%20surface%20with%20a%20colossal%20ringed%20planet%20in%20the%20sky%2C%20astronaut%20silhouette%20walking%20on%20rocky%20terrain%2C%20teal%20and%20amber%20glow%2C%20epic%20scale%2C%20soft%20atmospheric%20haze%2C%20moody%20lighting&width=1280&height=720&seq=vid-m01-backdrop&orientation=landscape",
    description:
      "人类首次驶向深空的载人远征，在孤独的星际旅途中，船员们必须面对未知信号带来的抉择与牺牲。",
    director: "亚瑟·雷诺兹",
    cast: ["林顿·凯奇", "艾米·洛", "周慕辰"],
    tags: ["科幻", "冒险", "太空"],
    publishDate: "2026-09-28",
  },
  {
    id: "m02",
    title: "城市之光",
    category: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "中国大陆",
    duration: "1小时56分",
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20neon%20city%20street%20at%20night%2C%20reflective%20wet%20asphalt%2C%20warm%20orange%20neon%20signs%20against%20cool%20blue%20shadows%2C%20gritty%20crime%20drama%20mood%2C%20detailed%20digital%20painting&width=480&height=720&seq=vid-m02-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20city%20at%20night%20backdrop%20with%20rain%20slicked%20streets%2C%20glowing%20neon%20signs%20and%20car%20light%20trails%2C%20lone%20figure%20walking%20away%20in%20the%20distance%2C%20moody%20teal%20and%20amber%20tones%2C%20film%20noir%20atmosphere%2C%20soft%20fog&width=1280&height=720&seq=vid-m02-backdrop&orientation=landscape",
    description:
      "一名老刑警在城市霓虹的阴影下追查连环案件，真相与良心在雨夜中不断交锋。",
    director: "陈志远",
    cast: ["韩振国", "苏晴", "李沐阳"],
    tags: ["犯罪", "悬疑", "都市"],
    publishDate: "2025-11-12",
  },
  {
    id: "m03",
    title: "山海秘境",
    category: "movie",
    categoryLabel: "电影",
    year: 2024,
    region: "中国大陆",
    duration: "2小时05分",
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20fantasy%20adventure%20movie%20poster%20of%20a%20traveler%20on%20a%20floating%20mountain%20island%2C%20misty%20valleys%20and%20ancient%20stone%20arches%2C%20golden%20sunrise%20light%20through%20clouds%2C%20teal%20and%20amber%20palette%2C%20rich%20detailed%20matte%20painting%2C%20epic%20mood&width=480&height=720&seq=vid-m03-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20fantasy%20landscape%20backdrop%20of%20towering%20misty%20mountains%20with%20waterfalls%20and%20ancient%20ruins%2C%20lone%20explorer%20silhouette%20on%20a%20cliff%2C%20golden%20hour%20light%2C%20teal%20shadows%2C%20atmospheric%20haze%2C%20epic%20scale&width=1280&height=720&seq=vid-m03-backdrop&orientation=landscape",
    description:
      "传说中藏在云海之上的秘境重新显现，一支探险队踏上寻找上古遗迹的旅程，揭开被遗忘的真相。",
    director: "徐山河",
    cast: ["白泽", "穆雪", "顾长风"],
    tags: ["奇幻", "冒险", "秘境"],
    publishDate: "2024-08-18",
  },
  {
    id: "m04",
    title: "追风少年",
    category: "movie",
    categoryLabel: "电影",
    year: 2026,
    region: "中国大陆",
    duration: "1小时48分",
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20young%20athlete%20sprinting%20on%20a%20running%20track%20at%20sunset%2C%20dynamic%20motion%20blur%20background%2C%20warm%20orange%20sky%20and%20cool%20blue%20tones%2C%20inspiring%20sports%20drama%20mood%2C%20detailed%20digital%20painting&width=480&height=720&seq=vid-m04-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sports%20backdrop%20of%20a%20stadium%20track%20at%20golden%20sunset%2C%20young%20runners%20in%20motion%2C%20dramatic%20warm%20light%20and%20long%20shadows%2C%20energetic%20youth%20drama%20atmosphere%2C%20soft%20lens%20flare&width=1280&height=720&seq=vid-m04-backdrop&orientation=landscape",
    description:
      "小城少年凭借天赋与坚持闯入职业赛场，在一次次跌倒与冲刺中，跑出属于自己的人生节奏。",
    director: "程野",
    cast: ["吴一凡", "林悦", "高声"],
    tags: ["青春", "运动", "励志"],
    publishDate: "2026-07-05",
  },
  {
    id: "m05",
    title: "无声告白",
    category: "movie",
    categoryLabel: "电影",
    year: 2023,
    region: "韩国",
    duration: "1小时42分",
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20drama%20poster%20of%20a%20young%20woman%20looking%20out%20a%20rain%20covered%20window%20at%20dusk%2C%20soft%20moody%20lighting%2C%20warm%20amber%20highlights%20and%20cool%20blue%20shadows%2C%20tender%20melancholic%20mood%2C%20detailed%20digital%20painting&width=480&height=720&seq=vid-m05-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20romance%20backdrop%20of%20an%20empty%20seaside%20boardwalk%20at%20twilight%2C%20soft%20pastel%20sky%2C%20two%20distant%20figures%2C%20gentle%20blue%20and%20warm%20amber%20tones%2C%20emotional%20calm%20atmosphere%2C%20soft%20focus&width=1280&height=720&seq=vid-m05-backdrop&orientation=landscape",
    description:
      "两个被生活推着前行的人在雨天的书店相遇，用最安静的方式说出藏在心底的那句话。",
    director: "金秀贤",
    cast: ["朴恩静", "李在勋", "徐妍"],
    tags: ["爱情", "剧情", "治愈"],
    publishDate: "2023-05-20",
  },
  {
    id: "m06",
    title: "暗夜猎手",
    category: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "英国",
    duration: "1小时51分",
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20thriller%20movie%20poster%20of%20a%20shadowy%20silhouette%20holding%20a%20flashlight%20in%20a%20dark%20forest%2C%20eerie%20cool%20blue%20mist%20and%20a%20single%20warm%20orange%20glow%2C%20tense%20suspenseful%20mood%2C%20highly%20detailed%20digital%20painting&width=480&height=720&seq=vid-m06-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20suspense%20backdrop%20of%20a%20dark%20foggy%20pine%20forest%20at%20night%20with%20a%20lone%20beam%20of%20light%2C%20deep%20blue%20shadows%20and%20faint%20amber%20glow%2C%20ominous%20atmospheric%20mood%2C%20film%20still%20quality&width=1280&height=720&seq=vid-m06-backdrop&orientation=landscape",
    description:
      "荒野深处的猎场接连发生失踪案，一名守林人在迷雾中追寻真相，却发现猎物与猎人的身份正在互换。",
    director: "奥利弗·格兰特",
    cast: ["丹尼尔·怀特", "艾拉·摩尔", "汤姆·里德"],
    tags: ["惊悚", "悬疑", "荒野"],
    publishDate: "2025-10-30",
  },
  {
    id: "t01",
    title: "长安烟云",
    category: "tv",
    categoryLabel: "电视剧",
    year: 2025,
    region: "中国大陆",
    duration: "全48集",
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20historical%20drama%20poster%20of%20a%20noble%20figure%20in%20ancient%20Chinese%20flowing%20robes%20standing%20before%20a%20grand%20palace%2C%20moonlit%20misty%20courtyard%2C%20lantern%20glow%20and%20deep%20blue%20night%2C%20elegant%20detailed%20digital%20painting%2C%20epic%20tone&width=480&height=720&seq=vid-t01-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20ancient%20Chinese%20palace%20backdrop%20at%20night%20under%20a%20full%20moon%2C%20misty%20courtyards%20and%20red%20lanterns%2C%20deep%20indigo%20shadows%20with%20warm%20golden%20glow%2C%20atmospheric%20historical%20drama%20film%20still&width=1280&height=720&seq=vid-t01-backdrop&orientation=landscape",
    description:
      "盛唐烟云之下，一位寒门学子凭才学踏入朝堂，在权谋与家国之间坚守初心，书写自己的传奇。",
    director: "赵启明",
    cast: ["陆云舟", "沈洛依", "裴锦年"],
    tags: ["古装", "权谋", "历史"],
    publishDate: "2025-09-15",
  },
  {
    id: "t02",
    title: "都市迷城",
    category: "tv",
    categoryLabel: "电视剧",
    year: 2026,
    region: "中国大陆",
    duration: "全36集",
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20urban%20drama%20poster%20of%20a%20confident%20young%20professional%20standing%20before%20a%20glassy%20skyscraper%2C%20reflected%20city%20lights%2C%20cool%20blue%20tones%20with%20warm%20orange%20accents%2C%20modern%20sleek%20mood%2C%20detailed%20digital%20painting&width=480&height=720&seq=vid-t02-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20modern%20cityscape%20backdrop%20at%20blue%20hour%2C%20glassy%20skyscrapers%20glowing%20with%20office%20lights%2C%20busy%20streets%20in%20soft%20motion%2C%20cool%20blue%20palette%20with%20warm%20spots%2C%20contemporary%20urban%20drama%20mood&width=1280&height=720&seq=vid-t02-backdrop&orientation=landscape",
    description:
      "在大都市打拼的年轻人面对职场竞争、友情与爱情的多重考验，在迷城中寻找属于自己的方向。",
    director: "何嘉树",
    cast: ["唐若溪", "赵一鸣", "许清欢"],
    tags: ["都市", "职场", "情感"],
    publishDate: "2026-06-20",
  },
  {
    id: "t03",
    title: "白衣执甲",
    category: "tv",
    categoryLabel: "电视剧",
    year: 2024,
    region: "中国大陆",
    duration: "全40集",
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20medical%20drama%20poster%20of%20a%20dedicated%20doctor%20in%20scrubs%20standing%20in%20a%20bright%20hospital%20corridor%2C%20soft%20cool%20blue%20and%20clean%20white%20lighting%2C%20warm%20hopeful%20accent%2C%20serious%20emotional%20mood%2C%20detailed%20digital%20painting&width=480&height=720&seq=vid-t03-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20hospital%20backdrop%20of%20a%20bright%20modern%20ward%20corridor%20with%20soft%20light%2C%20medical%20team%20walking%20in%20the%20distance%2C%20clean%20cool%20blue%20palette%20with%20gentle%20warm%20tones%2C%20hopeful%20drama%20film%20still&width=1280&height=720&seq=vid-t03-backdrop&orientation=landscape",
    description:
      "急诊科医生们在生死边缘守护生命，每一场抢救背后，都是医者仁心与平凡人的坚韧。",
    director: "林柏舟",
    cast: ["周铭", "苏晚晴", "顾知遇"],
    tags: ["医疗", "职业", "励志"],
    publishDate: "2024-12-01",
  },
  {
    id: "t04",
    title: "江湖夜雨",
    category: "tv",
    categoryLabel: "电视剧",
    year: 2023,
    region: "中国大陆",
    duration: "全42集",
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wuxia%20drama%20poster%20of%20a%20swordsman%20in%20flowing%20dark%20robes%20standing%20in%20rain%20on%20a%20bamboo%20forest%20path%2C%20misty%20green%20and%20deep%20blue%20tones%20with%20faint%20warm%20lantern%20glow%2C%20detailed%20painting%2C%20heroic%20mood&width=480&height=720&seq=vid-t04-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20ancient%20bamboo%20forest%20backdrop%20in%20soft%20rain%20and%20mist%2C%20lone%20swordsman%20silhouette%20on%20a%20stone%20path%2C%20atmospheric%20teal%20green%20and%20indigo%20tones%2C%20poetic%20martial%20arts%20film%20still&width=1280&height=720&seq=vid-t04-backdrop&orientation=landscape",
    description:
      "江湖恩怨十载未了，一位隐退剑客因故人重逢重出江湖，在夜雨中做出关乎道义的选择。",
    director: "白敬川",
    cast: ["段青崖", "温若鱼", "秦无涯"],
    tags: ["武侠", "古装", "江湖"],
    publishDate: "2023-04-08",
  },
  {
    id: "t05",
    title: "破晓时分",
    category: "tv",
    categoryLabel: "电视剧",
    year: 2026,
    region: "日本",
    duration: "全24集",
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20suspense%20series%20poster%20of%20a%20young%20detective%20gazing%20at%20a%20clue%20board%20in%20a%20dim%20room%2C%20single%20warm%20lamp%20against%20cool%20blue%20shadows%2C%20tense%20mysterious%20mood%2C%20highly%20detailed%20digital%20painting&width=480&height=720&seq=vid-t05-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20mystery%20backdrop%20of%20a%20sleepy%20town%20at%20dawn%20with%20fog%20rolling%20over%20empty%20streets%2C%20cool%20blue%20shadows%20and%20a%20thin%20line%20of%20warm%20sunrise%20light%2C%20quiet%20suspenseful%20atmosphere&width=1280&height=720&seq=vid-t05-backdrop&orientation=landscape",
    description:
      "小镇每十年便会出现一桩离奇旧案，年轻侦探在破晓前的迷雾里，追查被时间掩埋的真相。",
    director: "佐藤健一",
    cast: ["高桥凉介", "森川奈", "山口翔"],
    tags: ["悬疑", "推理", "剧情"],
    publishDate: "2026-03-14",
  },
  {
    id: "t06",
    title: "岁月长河",
    category: "tv",
    categoryLabel: "电视剧",
    year: 2022,
    region: "中国大陆",
    duration: "全50集",
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20drama%20poster%20of%20three%20generations%20standing%20together%20in%20front%20of%20an%20old%20courtyard%20house%2C%20warm%20golden%20afternoon%20light%2C%20gentle%20amber%20and%20soft%20blue%20tones%2C%20warm%20nostalgic%20mood%2C%20detailed%20painting&width=480&height=720&seq=vid-t06-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20family%20saga%20backdrop%20of%20an%20old%20countryside%20courtyard%20at%20golden%20hour%2C%20warm%20sunlight%20through%20tree%20leaves%2C%20distant%20figures%20sharing%20tea%2C%20warm%20amber%20palette%20with%20soft%20blue%20shadows%2C%20nostalgic%20mood&width=1280&height=720&seq=vid-t06-backdrop&orientation=landscape",
    description:
      "一家三代人跨越数十年光阴，在时代变迁中相互扶持，把平凡日子过成温暖长河。",
    director: "周立群",
    cast: ["赵德海", "王秀兰", "陈嘉言"],
    tags: ["家庭", "年代", "温情"],
    publishDate: "2022-10-02",
  },
  {
    id: "a01",
    title: "星动舞台",
    category: "variety",
    categoryLabel: "综艺",
    year: 2026,
    region: "中国大陆",
    duration: "每周五更新",
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20vertical%20concert%20poster%20of%20a%20singer%20under%20a%20spotlight%20on%20a%20glowing%20stage%2C%20colorful%20stage%20lights%20and%20crowd%20silhouettes%2C%20energetic%20blue%20and%20warm%20orange%20beam%20mix%2C%20exciting%20live%20show%20mood%2C%20detailed%20painting&width=480&height=720&seq=vid-a01-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20concert%20backdrop%20of%20a%20huge%20stage%20with%20dramatic%20light%20beams%20and%20glowing%20LED%20screens%2C%20crowd%20hands%20raised%2C%20energetic%20blue%20and%20amber%20lighting%2C%20vibrant%20music%20show%20atmosphere&width=1280&height=720&seq=vid-a01-backdrop&orientation=landscape",
    description:
      "实力唱将同台竞技，用一首首金曲点燃舞台，每一期都有全新的现场惊喜。",
    director: "本节目组",
    cast: ["沈星河", "安宁", "程亦飞"],
    tags: ["音乐", "竞技", "舞台"],
    publishDate: "2026-08-09",
  },
  {
    id: "a02",
    title: "美味奇遇",
    category: "variety",
    categoryLabel: "综艺",
    year: 2025,
    region: "中国大陆",
    duration: "全12期",
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Appetizing%20vertical%20food%20variety%20poster%20of%20a%20chef%20presenting%20a%20colorful%20sizzling%20dish%2C%20warm%20kitchen%20lighting%2C%20rich%20orange%20and%20fresh%20green%20tones%2C%20friendly%20warm%20mood%2C%20detailed%20digital%20painting%20style&width=480&height=720&seq=vid-a02-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20food%20variety%20backdrop%20of%20a%20cozy%20rustic%20kitchen%20with%20steaming%20dishes%20and%20fresh%20ingredients%20on%20a%20table%2C%20warm%20golden%20lighting%2C%20rich%20orange%20and%20soft%20blue%20accents%2C%20inviting%20mood&width=1280&height=720&seq=vid-a02-backdrop&orientation=landscape",
    description:
      "主持人与嘉宾走遍各地寻找地道风味，边做边吃边聊，用美食串联起温暖的城市记忆。",
    director: "本节目组",
    cast: ["林小满", "高大厨", "苏甜"],
    tags: ["美食", "生活", "治愈"],
    publishDate: "2025-11-03",
  },
  {
    id: "a03",
    title: "极限挑战营",
    category: "variety",
    categoryLabel: "综艺",
    year: 2026,
    region: "中国大陆",
    duration: "全10期",
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Energetic%20vertical%20reality%20show%20poster%20of%20contestants%20hiking%20up%20a%20dramatic%20mountain%20ridge%2C%20wide%20sky%20with%20warm%20sunrise%20and%20cool%20blue%20shadows%2C%20adventurous%20competitive%20mood%2C%20detailed%20digital%20painting&width=480&height=720&seq=vid-a03-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20outdoor%20reality%20show%20backdrop%20of%20a%20vast%20mountain%20valley%20at%20sunrise%2C%20team%20of%20hikers%20on%20a%20narrow%20trail%2C%20warm%20golden%20light%20and%20cool%20blue%20mist%2C%20epic%20adventurous%20atmosphere&width=1280&height=720&seq=vid-a03-backdrop&orientation=landscape",
    description:
      "明星嘉宾组成战队深入户外完成极限任务，在汗水与欢笑中挑战自我、突破极限。",
    director: "本节目组",
    cast: ["郑凯", "王大陆", "何炅"],
    tags: ["真人秀", "户外", "竞技"],
    publishDate: "2026-05-16",
  },
  {
    id: "a04",
    title: "快乐大本营",
    category: "variety",
    categoryLabel: "综艺",
    year: 2024,
    region: "中国大陆",
    duration: "全20期",
    rating: 8.0,
    cover: "https://readdy.ai/api/search-image?query=Fun%20colorful%20vertical%20poster%20of%20a%20cheerful%20talk%20show%20host%20on%20a%20playful%20stage%20set%2C%20bright%20studio%20lighting%2C%20lively%20warm%20orange%20and%20cool%20blue%20accents%2C%20joyful%20entertaining%20mood%2C%20detailed%20painting&width=480&height=720&seq=vid-a04-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20variety%20studio%20backdrop%20of%20a%20colorful%20playful%20talk%20show%20set%2C%20audience%20and%20stage%20props%2C%20bright%20warm%20and%20cool%20blue%20stage%20lighting%2C%20cheerful%20upbeat%20atmosphere&width=1280&height=720&seq=vid-a04-backdrop&orientation=landscape",
    description:
      "国民级欢乐脱口秀，游戏、访谈、互动轮番上阵，用笑声陪伴每一个周末夜晚。",
    director: "本节目组",
    cast: ["何炅", "谢娜", "李维嘉"],
    tags: ["脱口秀", "游戏", "搞笑"],
    publishDate: "2024-08-24",
  },
  {
    id: "a05",
    title: "声音的召唤",
    category: "variety",
    categoryLabel: "综艺",
    year: 2025,
    region: "中国大陆",
    duration: "全14期",
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20vertical%20singing%20competition%20poster%20of%20a%20contestant%20singing%20into%20a%20microphone%20under%20a%20spotlight%2C%20dark%20stage%20with%20warm%20amber%20glow%20and%20cool%20blue%20haze%2C%20emotional%20powerful%20mood%2C%20detailed%20painting&width=480&height=720&seq=vid-a05-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20stage%20backdrop%20of%20a%20singing%20competition%20with%20a%20lone%20performer%20in%20a%20spotlight%2C%20dark%20audience%20and%20dramatic%20amber%20and%20blue%20lighting%2C%20emotional%20intense%20atmosphere%2C%20soft%20haze&width=1280&height=720&seq=vid-a05-backdrop&orientation=landscape",
    description:
      "素人歌手凭独特嗓音登上舞台，在导师与观众的见证下，用声音讲述自己的故事。",
    director: "本节目组",
    cast: ["周深", "那英", "李健"],
    tags: ["音乐", "选秀", "情感"],
    publishDate: "2025-09-20",
  },
  {
    id: "a06",
    title: "环球旅行家",
    category: "variety",
    categoryLabel: "综艺",
    year: 2026,
    region: "中国大陆",
    duration: "全16期",
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20vertical%20travel%20show%20poster%20of%20a%20backpacker%20standing%20on%20a%20cliff%20overlooking%20a%20turquoise%20sea%2C%20warm%20sunset%20sky%2C%20vivid%20blue%20water%20and%20golden%20light%2C%20wanderlust%20adventurous%20mood%2C%20detailed%20painting&width=480&height=720&seq=vid-a06-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20travel%20backdrop%20of%20a%20stunning%20coastal%20cliff%20at%20golden%20sunset%20with%20turquoise%20ocean%20below%2C%20lone%20traveler%20silhouette%2C%20warm%20golden%20and%20vivid%20blue%20tones%2C%20breathtaking%20wanderlust%20mood&width=1280&height=720&seq=vid-a06-backdrop&orientation=landscape",
    description:
      "跟随镜头打卡全球宝藏目的地，用脚步丈量世界，记录旅途中不期而遇的惊喜。",
    director: "本节目组",
    cast: ["姜宇", "陈漫", "汪苏"],
    tags: ["旅行", "纪录", "生活"],
    publishDate: "2026-04-11",
  },
];

export function getVideoById(id: string): VideoItem | undefined {
  return videos.find((item) => item.id === id);
}